module.exports = __webpack_public_path__ + "img/Up Window.79f8052d.png";